import { render } from "./HeroiconsSolidLibrary.vue?vue&type=template&id=46f0dc25"
const script = {}

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLibrary.vue"]])

export default __exports__